<template>
  <g class="map-image">
    <image
      v-for="floorZoomLevel in currentFloorZoomLevels"
      :key="floorZoomLevel.level"
      :x="x"
      :y="y"
      :width="width"
      :height="height"
      :xlink:href="floorZoomLevel.image"
      :style="mapImageOpacity(floorZoomLevel.level)"
    />
  </g>
</template>

<script>
export default {
  computed: {
    currentBuilding: ({ $store, currentBuildingId }) => $store.getters['area/buildingFind'](currentBuildingId),
    currentBuildingId: ({ $store }) => $store.state.current.buildingId,
    currentFloor: ({ $store, currentFloorId }) => $store.getters['area/floorFind'](currentFloorId),
    currentFloorId: ({ $store }) => $store.state.current.floorId,
    currentMapZoomLevel: ({ $store }) => $store.state.map.zoomLevel,
    currentFloorZoomLevels() {
      // TODO: 板さんでzoomLevelのまだなので、暫定的にdefaultを出す処理
      // if (this.currentFloor.zoomLevels) {
      //   // NOTE: HTML上、詳細の画像が一番下に来るように降順に並べ替え
      //   this.currentFloor.zoomLevels.sort((a,b) => {
      //     // if (a.zoomLevel.level < b.zoomLevel.level) return 1;
      //     // if (a.zoomLevel.level > b.zoomLevel.level) return -1;
      //     return 0;
      //   });
      // } else {
      //   const defaultZoomLevel = { level: 8, image: this.currentFloor.image };
      //   this.currentFloor['zoomLevels'] = [defaultZoomLevel];
      // }

      // TODO: 暫定的に固定の画像を入れる
      return [
        {
          level: 7,
          image: this.currentFloor.image.url,
        },
      ];
    },
    mapMargin: () => ({
      top: 0.4,
      right: 0.4,
      bottom: 0.4,
      left: 0.4,
    }),
    height: (vm) => vm.currentBuilding.depth + vm.mapMargin.top + vm.mapMargin.bottom,
    width: (vm) => vm.currentBuilding.width + vm.mapMargin.left + vm.mapMargin.right,
    x: (vm) => -vm.mapMargin.left,
    y: (vm) => -(vm.currentBuilding.depth + vm.mapMargin.top),
  },
  methods: {
    mapImageOpacity(zoomLevel) {
      return {
        opacity: (zoomLevel >= this.currentMapZoomLevel) ? 1 : 0,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.map-image {
  image {
    transition: opacity .5s;
  }
}
</style>



// WEBPACK FOOTER //
// map_image.vue?20934e14